import React, { useState } from 'react';
import './SearchBar.css';
import clearIcon from '../assets/clear.png';
import Tooltip from './tooltip/Tooltip';

const SearchBar = ({ searchQuery, onSearchChange }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
      <div className="search-bar">
        <input
            type="text"
            placeholder="Search by name or keyword..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
        />
        <button
            className="clear-button"
            onClick={() => onSearchChange('')}
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
        >
          <div style={{ position: 'relative' }}>
            <img src={clearIcon} alt="Clear"/>
            {showTooltip && <Tooltip message="Clear" />}
          </div>
        </button>
      </div>
  );
}

export default SearchBar;
